import * as urls from '@/global/constants/routes'
import { NavbarDrawerGroup, NavbarMenuItem } from './Navbar.types'

/**
 * Menu principal do header, espelhando a navegacao do site em producao.
 * "Rede credenciada" aponta para a pagina de prestadores deste app.
 */
const mainMenu: NavbarMenuItem[] = [
  {
    title: 'Para membros',
    submenu: {
      caption: 'Alice. Saúde como deve ser.',
      links: [
        {
          title: 'Alice Agora',
          href: urls.FOR_MEMBERS_ALICE_NOW_URL,
          preview: {
            src: '/images/navbar/alice-agora.webp',
            alt: 'Imagem ilustrativa da funcionalidade Alice Agora'
          }
        },
        {
          title: 'Meu Médico Alice',
          href: urls.FOR_MEMBERS_FAMILY_DOCTOR_URL,
          preview: {
            src: '/images/navbar/meu-medico-alice.webp',
            alt: 'Médico de família da Alice em consulta com paciente'
          }
        }
      ]
    }
  },
  {
    title: 'Para empresas',
    href: urls.FOR_COMPANIES_URL,
    submenu: {
      caption: 'Entenda os diferenciais da Alice para sua empresa',
      links: [
        {
          title: 'Planos de saúde PJ',
          href: urls.PJ_HEALTH_PLAN_URL
        },
        {
          title: 'Plano de saúde PME',
          href: urls.PME_HEALTH_PLAN_URL
        },
        {
          title: 'Plano de saúde grandes empresas',
          href: urls.MLA_HEALTH_PLAN_URL
        },
        {
          title: 'Plano de saúde empresarial São Paulo',
          href: urls.SP_COMPANY_HEALTH_PLAN_URL
        },
        {
          title: 'Tabela de planos e preços',
          href: urls.PLANS_AND_PRICES_URL
        }
      ],
      cta: {
        title: 'Nossos diferenciais',
        href: urls.FOR_COMPANIES_URL
      }
    }
  },
  {
    title: 'Para médicos',
    href: urls.FOR_DOCTORS_URL
  },
  {
    title: 'Rede credenciada',
    href: urls.ACCREDITED_ESTABILISHMENTS_URL
  }
]

/**
 * Menu do hamburger, espelhando o `n-sidebar` do header em producao: tres
 * grupos rotulados, na mesma ordem.
 */
/*
 * Duracao da animacao de abertura e de fechamento do menu, em milissegundos.
 * Espelha o `reveal-down` e o `conceal-up` do `tailwind.config.js`: o painel
 * so pode desmontar depois que a saida termina.
 */
const MENU_ANIMATION_MS = 300

const drawerMenu: NavbarDrawerGroup[] = [
  {
    title: 'Sobre Alice',
    links: [
      { title: 'Institucional', href: urls.INSTITUTIONAL_URL },
      { title: 'Manifesto', href: urls.MANIFESTO_URL },
      { title: 'Ouvidoria', href: urls.OMBUDSMAN_URL },
      { title: 'Blog Alice', href: urls.BLOG_URL },
      { title: 'Blog Tech', href: urls.BLOG_TECH_URL }
    ]
  },
  {
    title: 'Faça parte do time',
    /*
     * "Carreiras para médicos" aponta para o mesmo portal de vagas. Em
     * producao o link nao tem destino: o href e a propria pagina com `#`.
     */
    links: [
      { title: 'Carreiras', href: urls.CAREER_URL },
      { title: 'Carreiras para médicos', href: urls.CAREER_URL }
    ]
  },
  {
    title: 'Venha para a Alice',
    links: [
      { title: 'Plano de saúde ME', href: urls.ME_HEALTH_PLAN_URL },
      { title: 'Plano de saúde PME', href: urls.PME_HEALTH_PLAN_URL },
      {
        title: 'Plano de saúde grandes empresas',
        href: urls.MLA_HEALTH_PLAN_URL
      },
      {
        title: 'Plano de saúde empresarial São Paulo',
        href: urls.SP_COMPANY_HEALTH_PLAN_URL
      },
      { title: 'Tabela de planos e preços', href: urls.PLANS_AND_PRICES_URL }
    ]
  }
]

export { drawerMenu, mainMenu, MENU_ANIMATION_MS }
